import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/Button';
import { AuthRoutes, Modules, PermissionActionsEnum, PermissionModulesEnum, RouteParamsTypes } from '../../../../enums';
import { AuthContext } from '../../../../contexts/AuthContext';
import { hasResourseAccess } from '../../../../utils/methods';

interface HeaderProps {
    edit: boolean;
    view: boolean;
    handleEditButtonClick: (e?: any) => void;
}

const Header: React.FC<HeaderProps> = ({
    edit,
    view,
    handleEditButtonClick
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasEditAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.Properties]: [PermissionActionsEnum.Update] }],
  });

  const hasAddAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.Properties]: [PermissionActionsEnum.Add] }],
  });

  const hasListAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.Properties]: [PermissionActionsEnum.View] }],
  });

  const handleGoToListClick = (e?: any) => {
     const url = Modules.properties + AuthRoutes.properties;
     if (e && (e.ctrlKey || e.metaKey)) {
         window.open(url, '_blank');
     } else {
         navigate(url);
     }
  };

  const handleAddNewClick = (e?: any) => {
    const url = Modules.properties + AuthRoutes.properties + RouteParamsTypes.add;
    if (e && (e.ctrlKey || e.metaKey)) {
        window.open(url, '_blank');
    } else {
        navigate(url);
    }
  };

  const title = edit
    ? t('properties.addEdit.pageTexts.title.editTitle')
    : view
    ? t('properties.addEdit.pageTexts.title.viewTitle')
    : t('properties.addEdit.pageTexts.title.addTitle');

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{title}</h4>
        <p>{t('properties.addEdit.pageTexts.header.subTitle')}</p>
      </div>
       <div className="col-6 d-flex align-items-center justify-content-end">
        {edit && hasAddAccess && (
          <Button
            className="btn btn-primary waves-effect waves-light me-3"
            text={t('properties.addEdit.pageTexts.title.addTitle')} // Or 'Add New', checking consistency. Usually 'header.addNew'
            onClick={handleAddNewClick}
          />
        )}
        {view && hasEditAccess && (
             <Button
                className="btn btn-primary waves-effect waves-light me-3"
                onClick={(e) => handleEditButtonClick(e)}
                text={t('properties.addEdit.pageTexts.header.editBtn')}
              />
        )}
        {hasListAccess && (
          <Button
            className="btn btn-primary waves-effect waves-light"
            onClick={handleGoToListClick}
            text={t('properties.addEdit.pageTexts.header.goToList')}
          />
        )}
      </div>
    </div>
  );
};

export default Header;
